/**
 * created on: 2019.04.08
 * 串联单详情页路由
 */
'use strict';
angular.module('broadcastPreviewRouterModule', [
		'broadcastSeriesSheetPreviewModule',
        'broadcastManuscriptPreviewModule'
	])
    .config(['$stateProvider', function($stateProvider) {
    	$stateProvider.state('broadcastseriesSheetPreview', {
    		url: '/broadcastseriessheetpreview?broadcastchannelid&broadcastchnldocid&broadcastsiteid&broadcastmetadataid&broadcastplatform&platform',
    		views: {
    			'': {
    				templateUrl: "./editingCenter/broadcast/preview/seriesSheetPreview/seriesSheetPreview_tpl.html",
                    
                    controller: "broadcastSeriesSheetPreviewCtrl"
    			}
    		}
    	}).state('broadcastmanuscriptPreview', {
            url: '/broadcastmanuscriptpreview?broadcastchannelid&broadcastchnldocid&broadcastsiteid&broadcastmetadataid&broadcastplatform&broadcasttypeid&isfromplannedorder&fromsearch',
            views: {
                '': {
                    templateUrl: "./editingCenter/broadcast/preview/manuscriptPreview/manuscriptPreview_tpl.html",
                    controller: "broadcastManuscriptPreviewCtrl"
                }
            }
        })
    }]);